const PUBLISHED_STATUS_ID = '4'
const DRAFT_STATUS_ID = '2'
const REVIEWING_PUBLICATION_STATUS_ID = '3'
const PUBLICATION_SOFT_REJECTED_STATUS_ID = '5'
const REVIEWING_CHANGES_STATUS_ID = '7'
const CHANGES_SOFT_REJECTED_STATUS_ID = '8'
const HARD_REJECTED_STATUS_ID = '10'
const EXPIRED_PUBLICATION_STATUS_ID = '11'

export const PUBLICATION_STATUS_IDS = {
  PUBLISHED: PUBLISHED_STATUS_ID,
  DRAFT: DRAFT_STATUS_ID,
  REVIEWING_PUBLICATION: REVIEWING_PUBLICATION_STATUS_ID,
  PUBLICATION_SOFT_REJECTED: PUBLICATION_SOFT_REJECTED_STATUS_ID,
  REVIEWING_CHANGES: REVIEWING_CHANGES_STATUS_ID,
  CHANGES_SOFT_REJECTED: CHANGES_SOFT_REJECTED_STATUS_ID,
  HARD_REJECTED: HARD_REJECTED_STATUS_ID,
  EXPIRED_PUBLICATION: EXPIRED_PUBLICATION_STATUS_ID
}
